import { render, staticRenderFns } from "./memory.vue?vue&type=template&id=42b7baff"
import script from "./memory.vue?vue&type=script&lang=js"
export * from "./memory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports